var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "is-flex is-justify-content-space-between" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Contact Person")]),
        _c(
          "button",
          {
            staticClass: "button is-small is-primary is-light",
            class: `is-light-btn-${_vm.$theme.name}`,
            attrs: { disabled: !_vm.$userInfo.isSystemAccount },
            on: { click: _vm.addNewContact },
          },
          [_c("span", { staticClass: "mso mso-24px" }, [_vm._v("add")])]
        ),
        _vm.companyContact
          ? _c("ContactModal", {
              attrs: {
                active: _vm.showContactModal,
                contact: _vm.companyContact,
              },
              on: {
                close: function ($event) {
                  _vm.showContactModal = false
                },
                save: _vm.addContact,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm.contacts && _vm.contacts?.length > 0
      ? _c(
          "div",
          [
            _vm._m(0),
            _vm._l(_vm.contacts, function (contact, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "field columns is-flex is-align-items-center",
                },
                [
                  _c("div", { staticClass: "column is-half" }, [
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: contact.firstName,
                            expression: "contact.firstName",
                          },
                        ],
                        staticClass: "input",
                        class: {
                          "is-danger":
                            _vm.$v.contacts.$each[index].firstName.$error,
                        },
                        attrs: {
                          type: "text",
                          placeholder: "First Name",
                          disabled: !_vm.$userInfo.isSystemAccount,
                        },
                        domProps: { value: contact.firstName },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                contact,
                                "firstName",
                                $event.target.value
                              )
                            },
                            function ($event) {
                              return _vm.$v.contacts.$each[index].$touch()
                            },
                          ],
                        },
                      }),
                      !_vm.$v.contacts.$each[index].firstName.required
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v("First Name is required "),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field has-addons column is-half" },
                    [
                      _c("div", { staticClass: "control is-expanded" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: contact.lastName,
                              expression: "contact.lastName",
                            },
                          ],
                          staticClass: "input",
                          class: {
                            "is-danger":
                              _vm.$v.contacts.$each[index].lastName.$error,
                          },
                          attrs: {
                            type: "text",
                            placeholder: "Last Name",
                            disabled: !_vm.$userInfo.isSystemAccount,
                          },
                          domProps: { value: contact.lastName },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  contact,
                                  "lastName",
                                  $event.target.value
                                )
                              },
                              function ($event) {
                                return _vm.$v.contacts.$each[
                                  index
                                ].lastName.$touch()
                              },
                            ],
                          },
                        }),
                        !_vm.$v.contacts.$each[index].lastName.required
                          ? _c("span", { staticClass: "help is-danger" }, [
                              _vm._v("Last Name is required "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button has-text-gold",
                            attrs: { disabled: !_vm.$userInfo.isSystemAccount },
                            on: {
                              click: function ($event) {
                                return _vm.setDefault(contact, "contacts")
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "mso mso-24px",
                                  class: [contact.isDefault ? "mso-fill" : ""],
                                },
                                [_vm._v(" star ")]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button has-text-primary",
                            on: {
                              click: function ($event) {
                                return _vm.editContact(contact, index)
                              },
                            },
                          },
                          [_vm._m(1, true)]
                        ),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button has-text-danger",
                            attrs: { disabled: !_vm.$userInfo.isSystemAccount },
                            on: {
                              click: function ($event) {
                                return _vm.removeContact(contact)
                              },
                            },
                          },
                          [_vm._m(2, true)]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            }),
          ],
          2
        )
      : _c("div", { staticClass: "label has-text-weight-normal ml-1" }, [
          _vm._v("No Contacts"),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field columns mb-0" }, [
      _c("div", { staticClass: "column is-half" }, [
        _c("label", { staticClass: "label has-text-weight-normal" }, [
          _vm._v("First Name"),
        ]),
      ]),
      _c("div", { staticClass: "column is-half" }, [
        _c("label", { staticClass: "label has-text-weight-normal" }, [
          _vm._v("Last Name"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-24px" }, [_vm._v(" edit ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-24px" }, [_vm._v("remove")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }